import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import type { LegacySmartTableMigrationRequest, LegacySmartTableMigrationResponse } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useMigrateLegacyToSmartTable = () => {
  const userToken = useAuth()?.userToken ?? "";
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const wid = Number(workspaceId);
  const queryClient = useQueryClient();

  return useMutation<LegacySmartTableMigrationResponse, unknown, LegacySmartTableMigrationRequest>({
    mutationFn: async payload => {
      const response = await fetch(ENDPOINTS.smart_table_legacy_migrations(wid), {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(payload),
      });

      return handleResponse(response) as Promise<LegacySmartTableMigrationResponse>;
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ["smart-tables", wid, "list"] });

      const migratedTableId = data.smart_table?.id;
      if (migratedTableId) {
        queryClient.invalidateQueries({ queryKey: ["smart-tables", wid, migratedTableId] });
        queryClient.invalidateQueries({
          queryKey: ["smart-tables", wid, migratedTableId, "bootstrap"],
        });
      }

      if (workspaceId) {
        queryClient.invalidateQueries({ queryKey: ["folder-entities", workspaceId] });
      }
    },
  });
};
